const trimDash = (str: string) => {
  if (str[str.length - 1] === '-') {
    return str.substr(0, str.length - 1);
  }
  return str;
};

export default trimDash;
